import React from "react";
import { Icon } from "@iconify/react";
import style from "./footer.module.css";
const Footer = () => {
  return (
    <div className={`${"footer"} ${style.footer}`}>
      <Icon icon="ant-design:copyright-circle-outlined" /> 2022 Tim Media
      Pimpinan Daerahh IPM Kabupaten Karawang
    </div>
  );
};

export default Footer;
